import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { findIndex } from '../../../utils';

import { addVariantToCartlist } from '../../../actions/cartlistActions';
import { addToWishlist } from '../../../actions/wishlistActions';

function ProductTwoMobile ( props ) {
    const { product, onAddToCart, showQuickView, isWishlist, onToggleWishlist } = props;

    const addToCartHandler = () => {
        if ( 0 !== product.stock )
            onAddToCart( product, 1 );
    }


    const addToWishlistHandler = () => {
        if ( isWishlist ) {
            window.location = process.env.REACT_APP_PUBLIC_URL + '/shop/wishlist';
        } else {
            onToggleWishlist( product, isWishlist );
        }
    }

    return (
        product ?
            <div className="col-12 mobile">


                {/*----------------------------------------------------- DEBUT --------------------------------------------------*/}


                <div className="row">
                    {/*image produit*/}
                    <div className="col-3">
                        {product.images.length > 0 &&
                        <Link to={ `${process.env.REACT_APP_PUBLIC_URL}/product/default/${product.id}`}>
                            <LazyLoadImage
                                alt="product"
                                src={ `${process.env.REACT_APP_API_URL}/uploads/variant_images/` + product.images[ 0 ].fileName }
                                threshold={ 400 }


                            />

                            { product.images[ 1 ] ?
                                <LazyLoadImage
                                    alt="product"
                                    src={ `${process.env.REACT_APP_API_URL}/uploads/variant_images/` + product.images[ 1 ].fileName }
                                    wrapperClassName="product-image-hover product-image"
                                    threshold={ 400 }
                                />
                                : ''
                            }
                        </Link>
                        }

                    </div>

                    {/*titre et informations*/}
                    <div className="col-7">
                        <h3 className="product-title"
                            style={{fontSize:16}}
                        >
                            <Link to={ `${process.env.REACT_APP_PUBLIC_URL}/product/default/${ product.id }` }>{ product.nameFr }</Link>
                        </h3>
                        <br/>

                        {
                            0 === product.stock ?
                                <div className="product-price">
                                    <span className="new-price">{ product.price.toLocaleString( undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) } MAD</span>
                                </div> :

                                0 < product.discount ?
                                    <div className="product-price">
                                        <span className="new-price">{ product.salePrice.toLocaleString( undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) } MAD</span>
                                        <span className="old-price">{ product.price.toLocaleString( undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) } MAD</span>
                                    </div> :

                                    <div className="product-price">{ product.price.toLocaleString( undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) } MAD</div>
                        }
                    </div>

                    {/*boutons*/}
                    <div className="col-2" style={{minHeight:110}}>
                        <ul>
                            <li>
                                <button
                                    className="btn-product btn-wishlist"
                                    title="Ajouter au favorits" onClick={ ( e ) => props.addToWishlist( product.id ) }
                                >
                                    {/*<span>ajouter au favorits</span>*/}

                                </button>
                            </li>
                            <li>
                                <button
                                    className="btn-product btn-cart"
                                    onClick={ ( e ) => props.addVariantToCartlist( product.id, 1, false ) }

                                >
                                    {/*<span>ajouter au panier</span>*/}
                                </button>
                            </li>
                        </ul>

                    </div>
                </div>
                <hr/>




                {/*----------------------------------------------------- FIN --------------------------------------------------*/}





            </div> : ' '
    );
}

export const mapStateToProps = ( state, ownprops ) => {
    return {
        isWishlist: ( findIndex( state.wishlist.list, item => item.id === ownprops.product.id ) !== -1 ) ? true : false
    };
}

export default connect( mapStateToProps, { addVariantToCartlist, addToWishlist } )( ProductTwoMobile );